import React from "react";
import Newton from "../swing_library/components/Newton/Newton";
import { NewtonProvider } from "../swing_library/components/Newton/store/NewtonContext";
import { MiniSwingLibraryProvider } from "../swing_library/components/Newton/store/miniSwingLibraryStore";

export const PdfWithCSS = () => {
  return (
    <div>
      <div style={{ height: "80vh" }}> </div>
      {/* <h1>Test</h1> */}

      <NewtonProvider>
        <MiniSwingLibraryProvider>
          <Newton />
        </MiniSwingLibraryProvider>
      </NewtonProvider>
    </div>
  );
};
